import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Accordion, AccordionTab } from "primereact/accordion";

const ResumenMensualDialog = ({
  visible,
  onHide,
  loading,
  matrixArray,
  columns,
  columnBodyTemplate
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  if (isMobile) {
    // Vista móvil mejorada: agrupa por año y muestra solo los meses con monto, con opción de colapsar por año
    const years = Array.from(new Set(matrixArray.map(row => row.year)));
    return (
      <Dialog
        visible={visible}
        onHide={onHide}
        modal
        style={{ width: '95vw', maxWidth: 420, padding: 0 }}
        contentStyle={{ padding: 0 }}
        header={"Resumen Mensual Neto"}
      >
        <div className="p-fluid formgrid grid" style={{ padding: 8 }}>
          <div className="col-12" style={{ textAlign: 'center', paddingBottom: 8 }}>
            <h6 style={{ margin: '4px 0 10px 0', fontSize: 14, color: '#666' }}>
              ¿Cuánto pagaré mensualmente?
            </h6>
          </div>
          <Card style={{ width: '100%', maxWidth: '100%', margin: 0, boxSizing: 'border-box' }}>
            <div className="col-12" style={{ overflowX: 'auto', marginTop: 0, padding: 0, width: '100%' }}>
              <style>{`
                .p-card-body {
                  padding: 0 !important;
                  width: 100% !important;
                  box-sizing: border-box;
                }
                .p-card.p-component {
                  width: 100% !important;
                  max-width: 100% !important;
                  margin-left: 0 !important;
                  margin-right: 0 !important;
                }
                .p-accordion, .p-accordion-content, .p-accordion-tab, .p-accordion-header {
                  width: 100% !important;
                  box-sizing: border-box;
                }
              `}</style>
              {matrixArray && matrixArray.length > 0 ? (
                <Accordion multiple>
                  {years.map((year, yearIdx) => {
                    const rowsOfYear = matrixArray.filter(row => row.year === year);
                    // Verificar si hay al menos un mes con monto en este año
                    const hayMesesConMonto = columns.filter(col => col.field !== 'year').some(col =>
                      rowsOfYear.some(row => {
                        const valor = row[col.field];
                        return valor !== null && valor !== undefined && valor !== '' && valor !== 0;
                      })
                    );
                    if (!hayMesesConMonto) return null;
                    return (
                      <AccordionTab key={year} header={`Año ${year}`}>
                        {columns.filter(col => col.field !== 'year').map((col, colIdx) => {
                          // Filtrar solo los meses con monto en este año
                          const mesesConMonto = rowsOfYear.filter(row => {
                            const valor = row[col.field];
                            return valor !== null && valor !== undefined && valor !== '' && valor !== 0;
                          });
                          if (mesesConMonto.length === 0) return null;
                          return (
                            <div
                              key={col.field}
                              style={{
                                borderRadius: 8,
                                boxShadow: '0 1px 4px #0001',
                                marginBottom: 10,
                                background: '#fff',
                                padding: 10,
                                border: '1px solid #eee',
                              }}
                            >
                              {mesesConMonto.map((row, rowIdx) => (
                                <div
                                  key={rowIdx}
                                  style={{
                                    padding: '6px 0',
                                    borderBottom:
                                      rowIdx < mesesConMonto.length - 1
                                        ? '1px dashed #e0e0e0'
                                        : 'none',
                                    color: '#444',
                                    fontWeight: 400,
                                    fontSize: 14,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 'bold',
                                      marginBottom: 6,
                                      fontSize: 15,
                                      paddingBottom: 4,
                                      letterSpacing: 0.2,
                                    }}
                                  >
                                    {col.header}
                                  </div>
                                  <span>
                                    {columnBodyTemplate
                                      ? columnBodyTemplate(row, col)
                                      : row[col.field]}
                                  </span>
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      </AccordionTab>
                    );
                  })}
                </Accordion>
              ) : (
                <div style={{ textAlign: 'center', color: '#888', fontSize: 15 }}>
                  No hay montos para este año
                </div>
              )}
            </div>
          </Card>
          <div className="col-12" style={{ textAlign: 'center', marginTop: 10 }}>
            <h5 style={{ margin: 0, fontSize: 13, color: '#b71c1c', fontWeight: 400 }}>
              *Tarifas con remarcador no incluidas, esto puede variar el precio final mensual a pagar
            </h5>
          </div>
        </div>
      </Dialog>
    );
  }

  // Vista web: Dialog y tabla normal
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      modal
      className="p-fluid product-dialog"
      header={"Resumen Mensual Neto"}
    >
      <div className="p-fluid formgrid grid">
        <div className="col-12 md:col-12" style={{ textAlign: "center" }}>
          <h6 style={{ marginBottom: "15px" }}>
            ¿Cuánto pagaré mensualmente?
          </h6>
        </div>

        <div
          className="flex justify-center col-12 md:col-12"
          style={{
            marginTop: "15px",
            textAlign: "center",
            paddingInline: "100px",
            overflowX: "auto",
          }}
        >
          <div className="w-full">
            <DataTable
              value={matrixArray}
              className="p-datatable-gridlines"
              showGridlines
              stripedRows
              emptyMessage="No hay montos para este año"
              loading={loading}
              scrollable
              scrollHeight="400px"
            >
              {columns.map((col, index) => (
                <Column
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  key={col.field}
                  field={col.field}
                  body={col.field !== "year" && columnBodyTemplate ? (rowData) => columnBodyTemplate(rowData, col) : undefined}
                  header={col.header}
                  headerClassName={"text-center font-semibold"}
                  bodyClassName={
                    index === 0
                      ? "text-center font-semibold"
                      : "text-center"
                  }
                />
              ))}
            </DataTable>
          </div>
        </div>

        <div className="col-12 md:col-12" style={{ textAlign: "center" }}>
          <h5 style={{ marginTop: "15px" }}>
            *Tarifas con remarcador no incluidas, esto puede variar el
            precio final mensual a pagar
          </h5>
        </div>
      </div>
    </Dialog>
  );
};

export default ResumenMensualDialog; 